import { Logo } from './brand/Logo';

// Legal pages live on the marketing host (cross-origin), so open in a new tab.
const LEGAL = {
  terms: 'https://www.lizrd.ai/terms',
  privacy: 'https://www.lizrd.ai/privacy',
};

/** Global page footer (shown in the authenticated app shell). */
export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-hairline">
      <div className="mx-auto flex max-w-4xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-muted sm:flex-row">
        <div className="flex items-center gap-2">
          <Logo size={16} />
          <span>© {year} Lizrd, Inc.</span>
        </div>
        <span className="text-center">Engineering Intelligence for Cloud Cost Optimization</span>
        <nav className="flex items-center gap-4">
          <a
            href={LEGAL.terms}
            target="_blank"
            rel="noreferrer"
            className="transition-colors hover:text-haze"
          >
            Terms
          </a>
          <a
            href={LEGAL.privacy}
            target="_blank"
            rel="noreferrer"
            className="transition-colors hover:text-haze"
          >
            Privacy
          </a>
        </nav>
      </div>
    </footer>
  );
}
